import { Img } from "container/Manual/components/content/Image";
import { Paragraph } from "container/Manual/components/content/Paragraph";
import { Li } from "container/Manual/components/list/Li";
import { Ul } from "container/Manual/components/list/Ul";
import { CardSection } from "container/Manual/components/section/CardSection";
import { ListSection } from "container/Manual/components/section/ListSection";

export const INT = () => {
  return (
    <CardSection id="INT" title="INT">
      <Paragraph>
        실수를 해당 숫자보다 작거나 같은 다음 정수로 반올림합니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>INT(VALUE)</Paragraph>
        <Ul>
          <Li>
            <b>VALUE</b>는 반올림하려는 실수입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>INT(`Column`)</Paragraph>
        <Img src="computeInt" />
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          제공하는 <b>VALUE</b>는 실수이거나, 실수를 포함하는 열이거나, 실수를
          반환하는 함수여야 합니다.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
